import { declareString } from "@1js/localization";

export const HandoffFileSelectionMenuOpenCloudFiles = declareString(
  "handoffFileSelectionMenu.openCloudFiles",
  {
    text: "Open cloud files",
    comment: `Menu item allowing customers to select one file from either SharePoint or OneDrive, depending on their account type. Clicking the menu item opens the document, and populates a prompt in its Copilot experience."`,
  }
);

export const HandoffFileSelectionMenuNewDocument = declareString(
  "handoffFileSelectionMenu.newDocument",
  {
    text: "New document",
    comment: `Menu item allowing customers to create a new document (e.g., Word-document, Excel-spreadsheet, OneNote notebook, PowerPoint slidedeck). Clicking the menu item creates the document, opens it, and populates a prompt in its Copilot experience.`,
  }
);
